module.exports = __webpack_public_path__ + "img/voucher_page_1.f1d4ee1c.png";